export default __webpack_public_path__ + "static/media/warning--trucks-rollover--g1.9615c47b.png";